import {useState} from 'react'
import {
    useGetMyOrganizationsQuery,
    useCreateMyOrganizationMutation,
} from 'store/Store.js'
import {i18n} from 'common.js'

export const getErrorMessage = (e) => e?.data?.message ?? 'Something went wrong'

const useMyOrganizations = () => {
    const {data, isLoading} = useGetMyOrganizationsQuery()
    const [doCreate, {isLoading: isCreating}] =
        useCreateMyOrganizationMutation()
    const [newName, setNewName] = useState('')
    const [snackbar, setSnackbar] = useState({open: false})

    const t = (text) => i18n.t(`myOrganizations.${text}`)

    const showSaved = () =>
        setSnackbar({open: true, severity: 'success', message: t('saved')})
    const showError = (e) =>
        setSnackbar({
            open: true,
            severity: 'error',
            message: getErrorMessage(e),
        })
    const closeSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return
        }
        setSnackbar((prev) => ({...prev, open: false}))
    }

    const handleNewNameChange = (event) => setNewName(event.target.value)

    const handleCreate = async (event) => {
        event.preventDefault()
        if (!newName.trim()) {
            return
        }
        try {
            await doCreate({name: newName.trim()}).unwrap()
            setNewName('')
            showSaved()
        } catch (e) {
            showError(e)
        }
    }

    return {
        t,
        organizations: data?.data || [],
        isLoading,
        newName,
        isCreating,
        handleNewNameChange,
        handleCreate,
        snackbar,
        closeSnackbar,
        showSaved,
        showError,
    }
}

export default useMyOrganizations
